import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { DashboardMetricCardsResponseModel } from '@/types'
import { DateType } from '@/utils/date'

export const getDashboardMetricCards = async (
  branchName: string,
  startMonth: string,
  endMonth: string,
  dateType: DateType
): Promise<DashboardMetricCardsResponseModel> => {
  try {
    const response = await axios.get(`${BASE_URL}/dashboard/metric-cards`, {
      params: {
        start_date: startMonth,
        end_date: endMonth,
        branch_names: branchName,
        date_type: dateType,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
